import 'babel-polyfill'

import React from 'react';
import ReactDOM from 'react-dom';

import { Provider } from 'react-redux';
import { createStore, applyMiddleware } from 'redux'
import thunkMiddleware from 'redux-thunk'
import { createLogger } from 'redux-logger'
import { loadingBarMiddleware } from 'react-redux-loading-bar'

import rootReducer from './store/reducers';
import './assets/css/bootstrap.min.css'
import './assets/css/app.min.css'
import './assets/css/icons.min.css'
import './styles/admin.generated.css'


import {
    BrowserRouter as Router,
    Route,
    Switch
} from 'react-router-dom'

import Login from './containers/LoginContainer';
import Dashboard from './containers/DashboardContainer';
import ClientDetail from './containers/ClientDetailContainer';
import AssetLibrary from './containers/AssetLibraryContainer';
import Events from './containers/EventsContainer';
import Report from './containers/ReportContainer';
import ReportPDF from './containers/ReportPDFContainer';
import EditEvent from './containers/EditEventContainer';
import Promo from './containers/PromoContainer';



const loggerMiddleware = createLogger()

const store = createStore(
    rootReducer,
    applyMiddleware(
        thunkMiddleware,
        loggerMiddleware,
        loadingBarMiddleware())
)


ReactDOM.render(

    <Provider store={store}>

        <Router>
            <Switch>
                <Route exact path="/" component={Login} />
                <Route exact path="/clients" component={Dashboard} />
                <Route exact path="/assets" component={AssetLibrary} />
                <Route exact path="/events" component={Events} />
                <Route exact path="/clients/new" component={ClientDetail} />
                <Route exact path="/clients/:clientId" component={ClientDetail} />
                <Route exact path="/events/*/*/edit" component={EditEvent} />
                <Route exact path="/events/*/*" component={Report} />                
                <Route exact path="/pdf/*" component={ReportPDF} />                
                <Route exact path="/events/*" component={Events} />
                <Route exact path="/promo" component={Promo} />
                
            </Switch>
        </Router>
    </Provider>
    ,

    document.getElementById('root')
);
